import { Component, OnInit, Input, ViewChild, ElementRef , OnChanges, AfterViewInit } from '@angular/core';
import { GlobalSearchService } from '../../../services/globalsearchservice.service'
import { DEFAULT_SALESMAN_ALLOWED } from '../../../classes/default-salesman-allowed';
import { PrintService } from '../../../services/print.service'
import { CustomerService } from '../../../services/customer.service'
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors, FormControl, FormGroup, FormArray } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs-compat/operator/filter';

@Component({
	selector: 'app-customer-total',
	templateUrl: './customer-total.component.html',
	styleUrls: ['./customer-total.component.scss']
})
export class CustomerTotalComponent implements OnInit, AfterViewInit {
	@Input() data: any = false;
	filename = 'customers';
	sending = false;
	salespeople: any = false;
	taxfilter = new UntypedFormControl(false);
	salesfilter = new UntypedFormControl(false);
	search = new UntypedFormControl('');
	taxes: any = false;
	tabledata: any = [];
	groupByDebtorno = false;


	headercolumns: string[] = [
		'debtorno',
		'name',
		'address1',
		'address2',
		'address3',
		'address4',
		'address5',
		'paymentterms',
		'termscodename',
		'phoneno',
		'email',
		'salesman',
		'salesmanname'
	];

	filteredBy = new FormControl('');
	filterList: any = [
		{
			view: 'Customer #',
			value: 'custbranch.debtorno'
		},
		{
			view: 'Customer Name',
			value: 'name'
		},
		{
			view: 'Address 1',
			value: 'address1'
		},
		{
			view: 'Address 2',
			value: 'address2'
		},
		{
			view: 'City',
			value: 'address3'
		},
		{
			view: 'Region',
			value: 'address4'
		},
		{
			view: 'Postal Code',
			value: 'Address5'
		},
		{
			view: 'Phone #',
			value: 'phoneno'
		},
		{
			view: 'Email',
			value: 'email'
		},
		{
			view: 'Terms Code',
			value: 'paymentterms'
		},
		{
			view: 'Terms Code Name',
			value: 'termscodename'
		},
		{
			view: 'Salesman Name',
			value: 'salesmanname'
		}];

	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild('filters') filters: MatSelect;
	config: any = [];
	user: any = false;
	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}

	obsValue: Observable<any>;
	searchsub: any = false;
	exporting: any = false;
	defaultFilters: any = ['email', 'phoneno', 'address3'];

	constructor(private customerService: CustomerService, private globalSearchService: GlobalSearchService, private printService: PrintService){
		this.globalSearchService.taxgroups.subscribe(r => {
			this.taxes = r;
		})

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u
				if(u.user.issalesman) {
					this.editsallowed = r.salesmanAllowed ?? DEFAULT_SALESMAN_ALLOWED
					if(this.config.env.client == 'hairlines'){
						this.defaultFilters = [];
					}
				}
				
			})
		});


		this.globalSearchService.salespeople.subscribe(r => {
			this.salespeople = r.filter((person) => person.group_id == 1 && person.current == 1);
		})
	}

	initFilters(){
		this.filters.options.forEach((item: MatOption) => this.defaultFilters.includes(item.value) ? item.select() : '');
	}

	ngAfterViewInit(): void {
		//setting of default search filters -> runs off filters 'value' val
		//current defaults : email, phone, city
		this.initFilters();
		
	}

	ngOnInit(): void {
		this.tabledata = new MatTableDataSource([]);
		this.tabledata.sort = this.sort;
		this.tabledata.paginator = this.paginator;
	}

	setData(data: any) {
		if(data) {
			this.tabledata = new MatTableDataSource(data);
			this.tabledata.sort = this.sort;
			this.tabledata.paginator = this.paginator;
		}
	}

	getDisplayData(): any[] {
		if (!this.data || !Array.isArray(this.data)) { return []; }
		if (!this.groupByDebtorno) { return this.data; }
		const seen = new Set<string>();
		return this.data.filter((row: any) => {
			const key = row.debtorno || '';
			if (seen.has(key)) { return false; }
			seen.add(key);
			return true;
		});
	}

	applyDisplayData() {
		const display = this.getDisplayData();
		this.tabledata = new MatTableDataSource(display);
		this.tabledata.sort = this.sort;
		this.tabledata.paginator = this.paginator;
	}

	//rendering in browser is too heavy. slows down the whole page load. Attempt to build the html outside teh dom
	buildHtmlForExport() {
		let html = '';
		const exportData = this.getDisplayData();
		if(exportData.length) {
			html = '<table class="table table-fixed table-sm" #print_table>';
			html += '<thead>';
			html += '<tr>';
			html += '<th>Customer#</th>';
			html += '<th>Name</th>';
			html += '<th>Address1</th>';
			html += '<th>Address2</th>';
			html += '<th>Address3</th>';
			html += '<th>Address4</th>';
			html += '<th>Address5</th>';
			html += '<th>Terms Code</th>';
			html += '<th>Terms Code Name</th>';
			html += '<th>Phone</th>';
			html += '<th>Email</th>';
			html += '<th>Salesman#</th>';
			html += '<th>Salesman Name</th>';
			html += '</tr>';
			html += '</thead>';
			html += '<tbody>';

			exportData.forEach( (d:any) => {
				html += '<tr *ngFor="let d of data" class="donotshow">'
				html += '<td>'
				html += d.debtorno
				html += '</td>'
				html += '<td>' +d.name+'</td>'
				html += '<td>' +d.address1+'</td>'
				html += '<td>' +d.address2+'</td>'
				html += '<td>' +d.address3+'</td>'
				html += '<td>' +d.address4+'</td>'
				html += '<td>' +d.address5+'</td>'
				html += '<td>' + (d.paymentterms || '') + '</td>'
				html += '<td>' + (d.termscodename || '') + '</td>'
				html += '<td>' +d.phoneno+'</td>'
				html += '<td>' +d.email+'</td>'
				html += '<td>' + (d.salesman || '') + '</td>'
				html += '<td>' + (d.salesmanname || '') + '</td>'
				html += '</tr>'
			});

			html += '</tbody>'
			html += '</table>'
		}
		return html;
	}

	filterCustomers() {
		const filters = {
			salesman: this.salesfilter.value,
			tax: this.taxfilter.value,
			search: this.search.value,
			wild: this.getActiveFilters()
		}

		if(this.searchsub) {
			this.searchsub.unsubscribe();
		}
		this.sending = true;
		
		this.searchsub = this.customerService.getAllCustomers(filters).subscribe(async(results: any) => {
			if(results) {
				this.data = results;
				this.applyDisplayData();
			}
			this.sending = false;
		});
	}

	getActiveFilters(){
		if(!this.filteredBy.value.length){
			return this.filterList.map((filter) => {return filter.value});
		}else{
			return this.filteredBy.value;
		}
	}

	exportPdf() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.buildHtmlForExport());
		const today = new Date();

		const filter = ( this.salesfilter.value.length > 1) ? this.salesfilter.value.join(', ') : '';

		const data = {
			content: encoded,
			filename: this.filename,
			title: 'All Customers',
			subtitle: 'Sales People:' + filter +' created '+today.toLocaleString(),
		}
		this.exporting = true;
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
			this.sending = false;
		});
	}

	exportXls() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.buildHtmlForExport());
		const today = new Date();
		const filter = ( this.salesfilter.value.length > 0) ? 'Sales People: '+this.salesfilter.value.join(', ') : '';

		const data = {
			content: encoded,
			filename: this.filename,
			title: 'All Customers',
			subtitle: filter +' created '+today.toLocaleString(),
		}
		this.exporting = true;
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
			this.exporting = false;
		});
	}
	ngOnChanges(changes: any) {
		if(changes.data) {
			this.filterCustomers();
		}
	}

	ngOnDestroy() {
		if (this.searchsub) { this.searchsub.unsubscribe(); }
	}

	selectAllToggle() {
		const selected = this.filters.options.find(opt => opt.selected);
		if (selected) {
			this.filters.options.forEach((item: MatOption) => item.deselect());
		} else {
			this.filters.options.forEach((item: MatOption) => item.select());
		}
	}

	trackByItemId(index: number, item: any): number {
		return item.debtorno;
	}
}
